// extracted by mini-css-extract-plugin
export var messageSideLeft = "_gj-1";
export var messageSideRight = "_gj-2";
export var subscribeToBackInStockBubbleContainer = "_gj-0";